<template>
  <div id="confirm">
    <CommonHeader />
    <div class="infoColumn"><span class="infoTitle">課金額</span></div>
    <p class="infoDescription"
      >毎月20,680円(税込)にてご利用いただけます。<br />※契約1ヶ月ごとの自動更新</p
    >

    <div class="infoColumn"><span class="infoTitle">氏名</span></div>
    <p class="infoDescription">{{ $route.params.name }}</p>

    <div class="infoColumn"><span class="infoTitle">性別</span></div>
    <p class="infoDescription">{{ sexOptions[$route.params.sex].label }}</p>

    <div class="infoColumn"><span class="infoTitle">生年月日</span></div>
    <p class="infoDescription">{{ $route.params.birthday }}</p>

    <div class="infoColumn"><span class="infoTitle">住所</span></div>
    <p class="infoDescription">{{ $route.params.streetAddress }}</p>

    <div class="infoColumn"><span class="infoTitle">メールアドレス</span></div>
    <p class="infoDescription">{{ $route.params.email }}</p>

    <div class="infoColumn"><span class="infoTitle">パスワード</span></div>
    <p class="infoDescription">{{ $route.params.password }}</p>

    <div class="infoColumn"><span class="infoTitle">電話番号</span></div>
    <p class="infoDescription">{{ $route.params.phoneNumber }}</p>

    <div class="infoColumn"><span class="infoTitle">招待コード</span></div>
    <p class="infoDescription">{{ $route.params.invitationCode }}</p>

    <div class="infoColumn"><span class="infoTitle">カード情報</span></div>
    <p class="infoDescription">**** **** **** {{ $route.params.last4 }}</p>

    <div class="accept">
      会員登録には、<a
        href="https://u-plus.jp/service-term.html"
        target="_blank"
        >利用規約</a
      >および<a href="https://u-plus.jp/privacy-policy.html" target="_blank"
        >個人情報保護方針</a
      >への同意が必要です
    </div>

    <DefaultButton class="button" @click.native="onNext"
      >同意して会員登録する</DefaultButton
    >
  </div>
</template>

<script>
import axios from 'axios'
import DefaultButton from '@components/atoms/button.vue'
import CommonHeader from '@components/organisms/common_header.vue'

export default {
  name: 'Confirm',
  components: {
    DefaultButton,
    CommonHeader,
  },
  data() {
    return {
      sex: 1,
      sexOptions: [
        { label: '男', value: '0' },
        { label: '女', value: '1' },
        { label: 'その他', value: '2' },
      ],
      onClicked: false,
    }
  },
  mounted() {
    if (Object.keys(this.$route.params).length === 0) {
      window.location = '/aube_001'
    }
  },
  methods: {
    onNext: function() {
      if (!this.onClicked) {
        this.onClicked = true
        axios
          .post('/users/tmp', {
            email: this.$route.params.email,
            password: this.$route.params.password,
            name: this.$route.params.name,
            sex: this.$route.params.sex,
            birthday: this.$route.params.birthday,
            street_address: this.$route.params.streetAddress,
            phone_number: this.$route.params.phoneNumber,
            card_token: this.$route.params.cardToken,
            invitation_code: this.$route.params.invitationCode,
            normal_flg: 3,
          })
          .then((res) => {
            this.$router.push({ name: 'complete' })
          })
          .catch(() => {
            alert('会員登録に失敗しました。UPLUSまでご連絡ください')
          })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../design/common-settings';

.headingSecond {
  margin-left: 20px;
  font-size: $header-second-size;
  font-weight: normal;

  &Comment {
    margin-bottom: 0;
    margin-left: 20px;
    font-size: $header-second-size;
    font-weight: normal;
  }
  &Under {
    width: 90%;
  }
}

.infoColumn {
  height: 40px;
  line-height: 40px;
  color: $bg-gray-text-color;
  text-align: left;
  background-color: $bg-gray-color;
}

.infoTitle {
  margin-left: 15px;
}

.infoDescription {
  margin-left: 20px;
}

.commentInput {
  width: 90%;
  margin: 20px 20px;
}

.button {
  margin-bottom: 20px;
  &Cheer {
    margin-bottom: 20px;
    background-color: $like-color;
  }
}
.accept {
  margin: 10px;
}
</style>
